import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'app-docu-renameable',
  templateUrl: './docu-renameable.component.html',
  styleUrls: ['./docu-renameable.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocuRenameableComponent {
  @Input() name: string;
  @Input() canRename = true;
  @Output() nameChange: EventEmitter<string> = new EventEmitter();

  renaming = false;
  draftName = '';

  startRenaming() {
    this.draftName = this.name;
    this.renaming = true;
  }

  updateName(newName: string) {
    this.draftName = newName;
  }

  finishRenaming() {
    if (!this.renaming) {
      return;
    }
    if (this.draftName !== this.name) {
      this.nameChange.emit(this.draftName);
    }
    this.renaming = false;
  }
}
